import gql from 'graphql-tag';

export default gql`
  mutation invitationUpdateCompany($input: InvitationUpdateCompanyInput) {
    invitationUpdateCompany(input: $input) {
      userErrors {
        field
        message
      }
      success
    }
  }
`;
